import { navLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer id="foot" className="border-t border-background-300 bg-background-200/60">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-10 px-4 py-12 md:px-6">
        {/* 顶部 CTA 条 */}
        <div className="flex flex-col items-center gap-5 overflow-hidden rounded-lg bg-background-100 p-7 text-center md:p-10">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-900">
            <i className="ri-bookmark-fill text-xl" />
          </span>
          <div>
            <h3 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">补课这件事，别只靠口口相传</h3>
            <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              把这一站收藏起来，黑料合集、汇总帖、整理清单与时间线整理随时回来翻。从入门看到资深，看98黑料这一站就够了。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-base text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-bookmark-line mr-1.5" />
              收藏本页
            </button>
            <a
              href="#top"
              className="whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-full border border-foreground-300 px-6 py-3 text-base text-foreground-800 transition-colors hover:border-foreground-950 hover:bg-foreground-950 hover:text-background-50"
            >
              回到顶部
              <i className="ri-arrow-up-line" />
            </a>
          </div>
        </div>

        {/* 页脚主体 */}
        <div className="flex flex-col justify-between gap-8 md:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
                98
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">黑料</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              把散落全网的黑料合集、汇总帖与整理清单集中呈现。按时间线理顺脉络，提供避雷指南，帮你快速掌握完整瓜点。
            </p>
          </div>

          <div className="flex flex-wrap gap-x-12 gap-y-6">
            <div className="flex flex-col gap-2.5">
              <p className="text-sm font-semibold text-foreground-950">站内导航</p>
              {navLinks.map((l) => (
                <a key={l.key} href={l.href} className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {l.label}
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-2.5">
              <p className="text-sm font-semibold text-foreground-950">覆盖板块</p>
              {["主播红人", "艺人圈", "游戏电竞", "饭圈塌房", "品牌翻车", "探店测评"].map((s) => (
                <a key={s} href="#collection" className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  {s}
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-2.5">
              <p className="text-sm font-semibold text-foreground-950">关注我们</p>
              <div className="flex items-center gap-2">
                {["ri-qq-line", "ri-weibo-line", "ri-wechat-line", "ri-remixicon-fill"].map((ic) => (
                  <a
                    key={ic}
                    href="#top"
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                    aria-label="关注渠道"
                  >
                    <i className={`${ic} text-lg`} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 底部条 */}
        <div className="flex flex-col gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 98黑料 · 吃瓜补课一站通</p>
          <p className="max-w-xl leading-relaxed">
            站内内容均为公开信息整理的静态展示，仅供娱乐参考；涉及事实请以官方及一手来源为准。如有误传请指正。
          </p>
        </div>
      </div>
    </footer>
  );
}